import { render, staticRenderFns } from "./VehiculoVPM.vue?vue&type=template&id=4c8b54a2&scoped=true&"
import script from "./VehiculoVPM.vue?vue&type=script&lang=js&"
export * from "./VehiculoVPM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8b54a2",
  null
  
)

export default component.exports